<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-10">
        <h1>{{ title }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{ title }}</span>
          <table
            mat-table
            [dataSource]="dataSource"
            class="gridData mt-2"
            matSort
          >
            <ng-container matColumnDef="lpn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                License Plate
              </th>
              <td mat-cell *matCellDef="let element">{{ element.lpn }}</td>
            </ng-container>
            <ng-container matColumnDef="permitId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Permit ID
              </th>
              <td mat-cell *matCellDef="let element">{{ element.permitId }}</td>
            </ng-container>
            <ng-container matColumnDef="citationStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                {{ element.citationStatus }}
              </td>
            </ng-container>
            <ng-container matColumnDef="carBootTow">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Boot Tow
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.carBootTow ? "Yes" : "No" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="citationTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Citation Time
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.citationTime | date : "y-MM-dd HH:mm:ss" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="fineAmount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Citation Amount
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.fineAmount }}
              </td>
            </ng-container>
            <ng-container matColumnDef="systemAutomatedReason">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason</th>
              <td mat-cell *matCellDef="let element">
                {{ element.systemAutomatedReason }}
              </td>
            </ng-container>
            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Comment</th>
              <td mat-cell *matCellDef="let element">{{ element.comment }}</td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-icon-button
                  matTooltip="View Citation Details"
                  class="iconbutton text-warning float-left"
                  (click)="viewCitationDialog(element.id)"
                >
                <i class="fas fa-eye"></i>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
